/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_No_PhotoInputs */

const cs_public_site_no_photo = /** @type {(inputs: Public_Site_No_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez fotografie`)
};

const en_public_site_no_photo = /** @type {(inputs: Public_Site_No_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No photo`)
};

/**
* | output |
* | --- |
* | "No photo" |
*
* @param {Public_Site_No_PhotoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_no_photo = /** @type {((inputs?: Public_Site_No_PhotoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_No_PhotoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_no_photo(inputs)
	return cs_public_site_no_photo(inputs)
});